import React from 'react';
import GoogleMapReact from 'google-map-react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { fetchOrganization } from '../../actions/authActions';
import {
  getProgram,
  requestToApply,
  fetchAuthorizedProgramSettings,
  askQuestion,
  fetchProgramContacts,
  clearQuestionCode,
} from '../../actions/programBrochureActions';
import moment from 'moment-timezone';
import { withCookies } from 'react-cookie';
import Carousel from '../../components/Admin/ProgramView/Carousel';
import ProgramViewDescription from '../../components/Admin/ProgramView/ProgramViewDescription';
import ProgramViewTestimonial from '../../components/Admin/ProgramView/ProgramViewTestimonial';
import ProgramViewAbout from '../../components/Admin/ProgramView/ProgramViewAbout';
import ProgramViewChart from '../../components/Admin/ProgramView/ProgramViewChart/ProgramViewChart';
import ProgramAmmenities from '../../components/Admin/ProgramView/ProgramAmmenities/ProgramAmmenities';
import ProgramScholarship from '../../components/Admin/ProgramView/ProgramScholarship/ProgramScholarship';
import ProgramEligibility from '../../components/Admin/ProgramView/ProgramEligibility/ProgramEligibility';
import ProgramOrganization from '../../components/Admin/ProgramView/ProgramOrganization/ProgramOrganization';
import StickyFooter from '../../components/StickyFooter';
import Loader from '../../components/Loader/Loader';
import QuestionModal from '../../components/QuestionModal/QuestionModal';
import PercentMatch from '../../components/PercentMatch/PercentMatch';
import EligibilityModal from '../../components/EligibilityModal/EligibiltiyModal';
import BlueModal from '../../components/BlueModal/BlueModal';
import ContactsModal from '../../components/ContactsModal/ContactsModal';
import { getPercentage } from '../../shared/helpers/getMatchPercent';
import s from './visitor-program-view.css';
import Alert from '../../components/AlertsOverlay/Alert';
import AlertsOverlay from '../../components/AlertsOverlay/AlertsOverlay';
import { addAlert } from '../../actions/alertActions';
import ViaIcon from '../../sites/plans/components/ViaIcon';
import Paragraph from '../../sites/components/library/paragraph';
import visitorCustomBranding from '../../hoc/customBranding/visitorCustomBranding';
import ProgramViewInfoBar from '../../components/Admin/ProgramView/ProgramViewInfoBar';
import AccessProtected from '../../sites/viaGlobal/components/pages/travelerProgramView/AccessProtected';
import { themeVia } from '../../styledComponents/settings/theme';
import { ThemeProvider } from 'styled-components';
import _isEmpty from 'lodash/isEmpty';

@visitorCustomBranding
class VisitorProgramView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      questionValue: '',
      eligibilityShow: false,
      requestShow: false,
      contactsShow: false,
      selectedRange: null,
      external_opened: false,
      programNotFind: true,
      showProgram: false,
    };

    this.convertPrice = this.convertPrice.bind(this);
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.showEligibilityModal = this.showEligibilityModal.bind(this);
    this.hideEligibilityModal = this.hideEligibilityModal.bind(this);
    this.showRequestModal = this.showRequestModal.bind(this);
    this.hideRequestModal = this.hideRequestModal.bind(this);
    this.showContactsModal = this.showContactsModal.bind(this);
    this.hideContactsModal = this.hideContactsModal.bind(this);
    this.askQuestion = this.askQuestion.bind(this);
    this.buttonOneHandler = this.buttonOneHandler.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.questionCode) {
      nextProps.questionCode == 200
        ? (this.props.addAlert('Message has been sent to Program Contact', 'success'), window.scrollTo(0, 0))
        : (this.props.addAlert('Something went wrong!', 'danger'), window.scrollTo(0, 0));

      this.props.clearQuestionCode();
    }
  }

  componentDidMount() {
    let parts = window.location.host.split('.');
    let subdomain = parts[0];
    this.props.fetchAuthorizedProgramSettings(this.props.id, 'visitor');
    this.props.getProgram(this.props.id, 'visitor');
    this.props.fetchOrganization(subdomain);
  }

  convertPrice(price) {
    const dollars = price / 100;

    return dollars.toLocaleString('en-US', { style: 'currency', currency: 'USD' }).slice(0, -3);
  }

  askQuestion = (id, data) => {
    this.props.askQuestion(id, data);
  };

  showModal = () => {
    this.setState({ show: false });
  };

  hideModal = () => {
    this.setState({
      show: false,
      questionValue: '',
    });
  };

  showEligibilityModal = () => {
    this.setState({ eligibilityShow: true });
  };

  hideEligibilityModal = () => {
    this.setState({ eligibilityShow: false });
  };

  showRequestModal = () => {
    this.setState({ requestShow: true });
  };

  hideRequestModal = () => {
    this.setState({ requestShow: false });
  };

  showContactsModal = () => {
    this.setState({ contactsShow: true });
  };

  hideContactsModal = () => {
    this.setState({ contactsShow: false });
  };

  openExternalUrl() {
    if (!this.state.external_opened) {
      window.open(this.props.programHash.external_application_url, '_blank');
      this.setState({ external_opened: true });
    }
  }

  buttonOneHandler() {
    window.location = `/traveler/programs`;
  }

  buttonTwoHandler() {
    window.location = `/traveler`;
  }

  showProgramNotFindModal = () => {
    this.setState({ programNotFind: true });
  };

  hideProgramNotFindModal = () => {
    this.setState({ programNotFind: false });
    window.location = `/traveler/programs`;
  };

  render() {
    const alias_program =
      this.props.organization && this.props.organization.info && this.props.organization.info.alias_program
        ? this.props.organization.info.alias_program
        : 'Program';

    if (
      this.props.loading == true ||
      (this.props.programHash === undefined && !!this.props.customBranding.branding_theme)
    ) {
      return <Loader />;
    } else if (this.props.program == null) {
      return (
        <div>
          <div>error</div>
        </div>
      );
    } else if (this.props.programStatus !== 'published') {
      return (
        <BlueModal
          show={this.state.programNotFind}
          handleClose={this.hideProgramNotFindModal}
          header="Oh No!"
          description="This program is currently not available."
          buttonOne="Explore Programs"
          buttonTwo="Back to Dashboard"
          buttonOneHandle={this.buttonOneHandler}
          buttonTwoHandle={this.buttonTwoHandler}
        />
      );
    } else if (this.props.authorized == false) {
      return (
        <BlueModal
          show={this.state.programNotFind}
          handleClose={this.hideProgramNotFindModal}
          header="Oh No!"
          description="This program is currently not available."
          buttonOne="Explore Programs"
          buttonTwo="Back to Dashboard"
          buttonOneHandle={this.buttonOneHandler}
          buttonTwoHandle={this.buttonTwoHandler}
        />
      );
    }
    const locations = this.props.locations
      .map(location => {
        if (location.city === '' || location.city === null) {
          return `${location.country}`;
        }
        return `${location.city}, ${location.country}`;
      })
      .join('; ');
    const ranges = this.props.programRanges.map(date => {
      if (date.use_exact_dates == true) {
        return `${moment(new Date(date.start_date)).format('MMM D[,] YYYY')} - ${moment(new Date(date.end_date)).format(
          'MMM D[,] YYYY',
        )}`;
      }
      return `${moment(new Date(date.start_date)).format('MMM [] YYYY')} - ${moment(new Date(date.end_date)).format(
        'MMM [] YYYY',
      )}`;
    });
    const subjects = this.props.programSubjects.map(sub => sub.name);
    const defaultLatLon = { lat: '40.7127281', lon: '-74.0060152' };
    const { lat, lon } = this.props.coordinates[0][0] ? this.props.coordinates[0][0].data : defaultLatLon;

    let percentage = this.props.percent[0] ? getPercentage(this.props.percent[0], parseInt(this.props.id)) : 0;

    return this.props.programHash.access_code_protected && !this.state.showProgram ? (
      <ThemeProvider theme={themeVia}>
        <div>
          <AccessProtected
            accessCode={this.props.programHash.access_code}
            setShowProgram={() => this.setState({ showProgram: !this.state.showProgram })}
            visitor
          />
        </div>
      </ThemeProvider>
    ) : (
      <div className={`${s.noPadding} container-fluid`}>
        {percentage > 30 ? <PercentMatch percent={percentage} /> : ``}
        <AlertsOverlay alerts={this.props.alerts}>
          <Alert />
        </AlertsOverlay>
        <Carousel
          role="Visitor"
          status="view"
          id={this.props.id}
          programStatus={this.props.programStatus}
          background={this.props.programHash.background_photo.url}
          authorized={this.props.authorized}
          ranges={this.props.programRanges}
          // authorized={this.props.authorized}
          openEligibility={this.showEligibilityModal}
          requestToApply={this.showRequestModal}
        />
        <QuestionModal
          show={this.state.show}
          id={this.props.id}
          handleClose={this.hideModal}
          askQuestion={this.props.askQuestion}
        />
        <EligibilityModal
          show={this.state.eligibilityShow}
          handleClose={this.hideEligibilityModal}
          ranges={this.props.ranges}
          authorized={this.props.authorized}
          selectedOption={this.state.selectedRange}
          eligibility={this.props.programEligibility.eligibility_info}
        />
        <BlueModal
          show={this.state.requestShow}
          handleClose={this.hideRequestModal}
          authorized={this.props.authorized}
          header="Request to Apply"
          description={`Currently there isn't a future term available for ${
            this.props.programHash.title
          } to apply to. But don't worry; sometimes new terms just haven't been added to the system yet. Requesting to Apply helps us understand who is interested in the program. So, here is what happens when you Request to Apply:`}
          buttonOne="Yes, Request to Apply"
          buttonTwo="No, Not Yet"
          buttonOneHandle={
            this.props.authorized == true
              ? this.props.programHash.external_application_url == null
                ? null
                : this.openExternalUrl()
              : this.props.requestToApply
          }
          buttonTwoHandle={this.hideRequestModal}
        />
        <ContactsModal
          show={this.state.contactsShow}
          handleClose={this.hideContactsModal}
          contacts={this.props.contacts}
          organizationDescription={this.props.organizationDescription}
          role="Visitor"
        />
        <div className="row no-gutters">
          <ProgramViewInfoBar
            programId={this.props.id}
            programProvider={this.props.provider}
            programTitle={this.props.programHash.title}
            userRole={'Visitor'}
            programContacts={this.props.contacts}
          />
          <ProgramViewDescription
            role="Visitor"
            status="view"
            id={this.props.id}
            title={this.props.programHash.title}
            description={this.props.programHighlight.text ? this.props.programHighlight.text : ''}
            subdescription={this.props.programLocation.text}
            locations={locations}
            programTypes={this.props.programTypes}
            low={this.props.programRanges[0] ? this.convertPrice(this.props.programRanges[0].low_cost_cents) : 0}
            high={this.convertPrice(this.props.programRanges[0] ? this.props.programRanges[0].high_cost_cents : 0)}
            provider={this.props.provider}
            ranges={ranges}
            subjects={subjects}
            showContacts={this.showContactsModal}
            handleContactsClose={this.hideContactsModal}
            showModal={this.showModal}
            favorite={this.props.programFavorite != null}
            programId={this.props.id}
            contacts={this.props.contacts}
            aliasProgram={alias_program}
          />
        </div>
        <div className="row no-gutters">
          <div className="col-sm-8">
            {this.props.programReview.review_text ? (
              <ProgramViewTestimonial
                role="Traveler"
                status="view"
                reviewText={this.props.programReview.review_text}
                name={this.props.programReview.reviewer_name}
                details={this.props.programReview.reviewer_details}
              />
            ) : (
              ``
            )}
          </div>
        </div>
        {this.props.programMap && defaultLatLon.lat !== lat && defaultLatLon.lon !== lon ? (
          <div className="row no-gutters">
            <div className={s.mapWrapper}>
              {
                <GoogleMapReact
                  bootstrapURLKeys={{
                    key: 'AIzaSyDyZnxFjwYKZv_QCVKkOAUpOxDOSMmFOJA',
                  }}
                  center={{
                    lat: Number(lat),
                    lng: Number(lon),
                  }}
                  zoom={12}
                />
              }
            </div>
          </div>
        ) : (
          <div />
        )}
        <ProgramViewAbout
          role="Visitor"
          status="view"
          immersion={this.props.programHash.language_immersion}
          languages={this.props.programLanguages}
          locations={this.props.locations}
          subjects={this.props.programSubjects}
          courses={this.props.programCourses}
          activites={this.props.programActivities}
          excursions={this.props.programExcursions}
          housing={this.props.programHousing}
          additionals={this.props.programOpportunities}
          alias_program={alias_program}
          pActivities={this.props.pActivities}
          pExcursions={this.props.pExcursions}
          pAddons={this.props.pAddons}
          pCourses={this.props.pCourses}
          activityNotes={this.props.activityNotes}
          locationNotes={this.props.locationNotes}
          housingNotes={this.props.housingNotes}
          hostOrg={this.props.hostOrg}
          hostOrgNotes={this.props.hostOrgNotes}
          academicNotes={this.props.academicNotes}
          programTypes={this.props.programTypes}
        />
        <div className="row no-gutters">
          <div className="col-sm-12">
            <ProgramViewChart
              role="Visitor"
              status="view"
              authorized={this.props.authorized}
              authorizedProgram={this.props.authorizedProgram}
              openEligibility={this.showEligibilityModal}
              requestToApply={this.showRequestModal}
              client_account={this.props.programHash.primary_client_account_id}
              ranges={this.props.ranges}
              orgTimeZone={this.props.orgTimeZone}
              provider={this.props.provider}
              internal_program={this.props.internal_program}
              aliasProgram={alias_program}
            />
          </div>
        </div>
        {this.props.programAmenitiesIncluded.length > 0 && (
          <div className="row no-gutters">
            <div className="col-sm-12">
              <ProgramAmmenities
                role="Traveler"
                status="view"
                idAmmenities={this.props.programAmenitiesIncludedWithId}
                ammenities={this.props.programAmenities}
                included={this.props.programAmenitiesIncluded}
                excluded={this.props.programAmenitiesExcluded}
                aliasProgram={alias_program}
              />
            </div>
          </div>
        )}
        <div className="row no-gutters">
          <div className="col-sm-12">
            {this.props.programEligibility.eligibility_info ? (
              <ProgramEligibility
                role="Traveler"
                status="view"
                eligibility={this.props.programEligibility.eligibility_info}
              />
            ) : (
              ``
            )}
          </div>
        </div>
        <div className="row no-gutters">
          <div className="col-sm-12">
            {!_isEmpty(this.props.programScholarship) && !_isEmpty(this.props.programScholarship.scholarship_info) ? (
              <ProgramScholarship role="Traveler" status="view" financialAid={this.props.programScholarship} />
            ) : (
              ``
            )}
          </div>
        </div>
        {this.props.organizationDescription ? (
          <div className="row no-gutters">
            <div className="col-sm-12">
              <ProgramOrganization
                role="Visitor"
                status="view"
                organizationDescription={this.props.organizationDescription}
                provider={this.props.provider}
              />
            </div>
          </div>
        ) : (
          ''
        )}
        <div className="row no-gutters">
          <div className="col-sm-12">
            <StickyFooter
              role="Visitor"
              status="view"
              ranges={this.props.programRanges}
              openEligibility={this.showEligibilityModal}
              authorized={this.props.authorized}
              requestToApply={this.showRequestModal}
              id={this.props.id}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  program: state.program.program,
  authorizedProgram: state.program.authorizedProgram,
  percent: state.program.percent,
  percentLoading: state.program.percentLoading,
  contacts: state.program.contacts,
  contactsLoading: state.program.contactsLoading,
  authorizedProgramLoading: state.program.authorizedProgramLoading,
  loading: state.program.programLoading,
  requestSent: state.program.requestSent,
  programHash: state.program.programHash.program,
  ranges: state.program.programHash.ranges,
  programRanges: state.program.programHash.program_ranges,
  programHighlight: state.program.programHash.program_highlight,
  programEligibility: state.program.programHash.program_eligibility,
  programAmenities: state.program.programHash.program_amenities,
  programAmenitiesIncludedWithId: state.program.programHash.ProgramAmenitiesIncludedWithId,
  programAmenitiesIncluded: state.program.programHash.program_amenities_included,
  programAmenitiesExcluded: state.program.programHash.program_amenities_excluded,
  programReview: state.program.programHash.program_review ? state.program.programHash.program_review : {},
  programExcursions: state.program.programHash.program_excursions,
  programSubjects: state.program.programHash.program_subjects,
  programTypes: state.program.programHash.program_types,
  programLocation: state.program.programHash.program_location,
  programActivities: state.program.programHash.program_activity,
  programCourses: state.program.programHash.program_courses,
  programHousing: state.program.programHash.program_housing,
  programScholarship: state.program.programHash.program_scholarship,
  programLanguages: state.program.programHash.program_languages,
  coordinates: state.program.programHash.coordinates,
  programMap: state.program.programHash.program_map,
  locations: state.program.programHash.locations,
  programStatus: state.program.programHash.publish_status,
  provider: state.program.programHash.provider,
  programFavorite: state.program.programHash.program_favorite,
  authorized: state.program.programHash.authorized,
  programOpportunities: state.program.programHash.program_opportunities,
  organizationDescription: state.program.programHash.organization_description,
  alerts: state.alerts,
  questionCode: state.program.questionCode ? state.program.questionCode : null,
  customBranding: state.program.programHash.branding_theme || {},
  pActivities: state.program.programHash.pactivities,
  pExcursions: state.program.programHash.pexcursions,
  pAddons: state.program.programHash.padd_ons,
  activityNotes: state.program.programHash.activity_notes,
  pCourses: state.program.programHash.pcourses,
  orgTimeZone: state.program.programHash.organization_time_zone,
  locationNotes: state.program.programHash.location_notes,
  housingNotes: state.program.programHash.housing_notes,
  hostOrg: state.program.programHash.host_organization,
  hostOrgNotes: state.program.programHash.host_organization_notes,
  academicNotes: state.program.programHash.academic_notes,
  internal_program: state.program.programHash.internal,
  organization: state.auth.organization,
});

export default compose(
  withCookies,
  withStyles(s),
  connect(
    mapStateToProps,
    {
      fetchOrganization,
      getProgram,
      requestToApply,
      fetchAuthorizedProgramSettings,
      askQuestion,
      fetchProgramContacts,
      addAlert,
      clearQuestionCode,
    },
  ),
)(VisitorProgramView);
